<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-sell-out`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 17a1 1 0 011-1h2a1 1 0 011 1v23h32V17a1 1 0 011-1h2a1 1 0 011 1v25a2 2 0 01-2 2H6a2 2 0 01-2-2V17zm10.658-4.846l7.778-7.778a2 2 0 012.828 0l7.778 7.778a1 1 0 010 1.415l-1.414 1.414a1 1 0 01-1.414 0l-4.235-4.235-.08 18.206a1 1 0 01-.996.996l-1.894.008a1 1 0 01-1.004-.996v-.009l.082-18.572-4.601 4.602a1 1 0 01-1.414 0l-1.414-1.414a1 1 0 010-1.415z"/></svg>
</template>
<script>

export default {
  name: 'IconSellOut',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
